import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {translate} from "translate"
import "./footer.css"
import {Button, Row, Col} from "elemental"
import {Link} from "react-router"

const BackToTop = ({onClick}) => {
  return (
    <button onClick={onClick} className="back-to-top tc">{translate("shop.to_top")}</button>
  )
}

BackToTop.propTypes = {
  onClick: PropTypes.func.isRequired
}

const MenuCustomCategories = () => {
  return (
    <div className="container tc">
      <Button type="link" onClick={() => {window.scrollTo(0,0)}}>{translate("shop.to_top")}</Button>
    </div>
  )
}

class Footer extends Component {
  constructor(props) {
    super(props)
  }

  handleBackToTop = () => {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <footer className="footer mt5">
        <div className="container-fluid navigation-bar">
          <MenuCustomCategories/>
        </div>

        <section style={{paddingTop: "45px"}}>
          <div className="container cols ">
            <Row>

              <Col md="1/4">
                <h4>Info</h4>
                <Link to="/cms/versandkosten">{translate("footer.delivery")}</Link> <br />
                <Link to="/cms/agb">{translate("footer.AGB")}</Link> <br />
                <Link to="/cms/impressum">{translate("footer.imprint")}</Link> <br />
                <Link to="/cms/kontakt">{translate("footer.contact")}</Link>
              </Col>

              <Col md="1/4">
                <h4>Service</h4>
                <Link to="/form/customer_contact">{translate("footer.contact")}</Link> <br />
                <Link to="/form/catalog_request">{translate("footer.request_catalogue")}</Link> <br />
                {/*<Link to="/form/customer_registration">{translate("footer.new_client")}</Link> <br />*/}
                {/*<Link to="/form/change-address">{translate("footer.change_address")}</Link> <br />*/}
              </Col>

              <Col md="1/4">
                <h4>Shop</h4>
                {/*<Link to="#">Kontoeinstellungen</Link> <br />*/}
                {/*<Link to="#">Adressänderungen</Link> <br />*/}
                <Link to="/quickorder">{translate("nav.quickorder")}</Link> <br />
              </Col>

              <Col md="1/4">
                <br/> <br/>

                <p>
                  MAGS Vertriebs GmbH<br/>
                  Stuttgarter Str. 20<br/>
                  75395 Ostelsheim
                </p>

                <p><strong>TELEFON: +49&nbsp;(0)&nbsp;7033&nbsp;-&nbsp;46&nbsp;66&nbsp;80</strong></p>
              </Col>

            </Row>
          </div>
        </section>

        <section className="socket"
                 style={{paddingTop: "45px"}}>
          <div className="container">
            <Row>
              <Col sm="1/5"> </Col>
              <Col sm="3/5">
                <p className="tc text-small"><Link to="/cms/datenschutz">{translate("nav.privacy")}</Link>
                </p>
              </Col>
              <Col sm="1/5"> </Col>
            </Row>
          </div>
        </section>

      </footer>
    )
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js